/* assets/rush-widget.js
   Works with snippets/rush-widget.liquid (data-rush-widget markup)
   LA-time locked, supports multiple widgets per page
*/
(function () {
  'use strict';

  // -----------------------------
  // Config (edit these only)
  // -----------------------------
  var CFG = {
    TZ: 'America/Los_Angeles',

    PROD_START_HOUR: 6,   // production starts (used for countdown targets)
    CUTOFF_HOUR: 12,      // rush cutoff (noon)
    READY_TIME_TODAY_AM: '12:00 PM Today',
    READY_TIME_TODAY_PM: '4:00 PM Today',
    READY_TIME_TOMORROW: '12:00 PM Tomorrow',
    READY_TIME_MONDAY: '12:00 PM Monday',

    // Slots / scarcity
    MAX_SLOTS: 22,
    MIN_DISPLAY: 2, // never show below this during open window (prevents "0 spots" while still technically open)
    SLOT_MSG_DEFAULT: 'Same-day rush capacity',
    SLOT_MSG_MID: 'Filling up this morning',
    SLOT_MSG_LOW: 'Almost full — press run closing',
    SLOT_MSG_CRITICAL: 'Last rush spots for today',

    // Reserve message (no innerHTML/emoji injection to avoid duplicate icons)
    RESERVE_TOMORROW_TEXT: 'Today’s Production Closed — Order Now',
    RESERVE_MONDAY_TEXT: 'Reserve Now, Ready Monday',

    // Countdown label
    COUNTDOWN_LABEL: 'Add "Same-Day Rush" within'
  };

  var DAYS = { SUN: 0, MON: 1, FRI: 5, SAT: 6 };

  // -----------------------------
  // Time helpers (LA-locked)
  // -----------------------------
  function nowLA() {
    // Wall-clock LA time (even if visitor is elsewhere)
    return new Date(new Date().toLocaleString('en-US', { timeZone: CFG.TZ }));
  }

  function clone(d) {
    return new Date(d.getTime());
  }

  function setHMS(d, hour, min, sec, ms) {
    var x = clone(d);
    x.setHours(hour, min || 0, sec || 0, ms || 0);
    return x;
  }

  function addDays(d, n) {
    var x = clone(d);
    x.setDate(x.getDate() + n);
    return x;
  }

  function secondsBetween(a, b) {
    return Math.max(0, Math.floor((b.getTime() - a.getTime()) / 1000));
  }

  function formatHM(totalSeconds) {
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    return h + ' hrs ' + m + ' mins';
  }

  function nextMondayAtSix(now) {
    var d = clone(now);
    while (d.getDay() !== DAYS.MON) d = addDays(d, 1);
    return setHMS(d, CFG.PROD_START_HOUR, 0, 0, 0);
  }

  function nextBusinessDayAtSix(now) {
    // next day 6am, skipping Sat/Sun
    var d = addDays(now, 1);
    d = setHMS(d, CFG.PROD_START_HOUR, 0, 0, 0);
    while (d.getDay() === DAYS.SAT || d.getDay() === DAYS.SUN) {
      d = addDays(d, 1);
      d = setHMS(d, CFG.PROD_START_HOUR, 0, 0, 0);
    }
    return d;
  }

  // -----------------------------
  // State logic (countdown + ready text)
  // -----------------------------
  function computeCountdownState(now) {
    var day = now.getDay();
    var hr = now.getHours();
    var min = now.getMinutes();
    var t = hr + min / 60;

    var weekend = (day === DAYS.SAT || day === DAYS.SUN);
    var fridayAfterCutoff = (day === DAYS.FRI && t >= CFG.CUTOFF_HOUR);

    // Weekend OR Friday after noon -> Monday
    if (weekend || fridayAfterCutoff) {
      var mon6 = nextMondayAtSix(now);
      return {
        warn: true,
        countdownTo: mon6,
        readyText: CFG.READY_TIME_MONDAY
      };
    }

    // Before production opens (before 6am) -> ready by 12pm today, countdown to 6am
    if (t < CFG.PROD_START_HOUR) {
      var six = setHMS(now, CFG.PROD_START_HOUR, 0, 0, 0);
      return {
        warn: false,
        countdownTo: six,
        readyText: CFG.READY_TIME_TODAY_AM
      };
    }

    // Open window (6am-noon) -> ready by 4pm today, countdown to noon cutoff
    if (t >= CFG.PROD_START_HOUR && t < CFG.CUTOFF_HOUR) {
      var noon = setHMS(now, CFG.CUTOFF_HOUR, 0, 0, 0);
      return {
        warn: false,
        countdownTo: noon,
        readyText: CFG.READY_TIME_TODAY_PM
      };
    }

    // After cutoff Mon-Thu -> tomorrow (or next business day if Fri handled above)
    var next6 = nextBusinessDayAtSix(now);
    return {
      warn: true,
      countdownTo: next6,
      readyText: (next6.getDay() === DAYS.MON ? CFG.READY_TIME_MONDAY : CFG.READY_TIME_TOMORROW)
    };
  }

  // -----------------------------
  // Slots logic (scarcity)
  // -----------------------------
  function computeSlotsState(now) {
    var day = now.getDay();
    var hr = now.getHours();
    var min = now.getMinutes();
    var t = hr + min / 60;

    // Weekend => reserve Monday
    if (day === DAYS.SAT || day === DAYS.SUN) {
      return { remaining: 0, headText: CFG.RESERVE_MONDAY_TEXT, stateClass: 'is-queue' };
    }

    // Friday after cutoff => reserve Monday
    if (day === DAYS.FRI && t >= CFG.CUTOFF_HOUR) {
      return { remaining: 0, headText: CFG.RESERVE_MONDAY_TEXT, stateClass: 'is-queue' };
    }

    // Before production opens => show full capacity (you can change copy if you want)
    if (t < CFG.PROD_START_HOUR) {
      return { remaining: CFG.MAX_SLOTS, headText: CFG.SLOT_MSG_DEFAULT, stateClass: '' };
    }

    // After cutoff Mon–Thu => reserve tomorrow
    if (t >= CFG.CUTOFF_HOUR) {
      return { remaining: 0, headText: CFG.RESERVE_TOMORROW_TEXT, stateClass: 'is-queue' };
    }

    // During 6am–noon: burn down capacity as time passes
    var minutesSinceStart = (hr - CFG.PROD_START_HOUR) * 60 + min;  // 0..360
    var windowMinutes = (CFG.CUTOFF_HOUR - CFG.PROD_START_HOUR) * 60; // 360

    var used = Math.floor((minutesSinceStart / windowMinutes) * CFG.MAX_SLOTS);
    var remainingRaw = CFG.MAX_SLOTS - used;
    var remaining = Math.max(CFG.MIN_DISPLAY, remainingRaw);

    // Messaging thresholds
    if (remaining <= 2)  return { remaining: remaining, headText: CFG.SLOT_MSG_CRITICAL, stateClass: 'is-critical' };
    if (remaining <= 5)  return { remaining: remaining, headText: CFG.SLOT_MSG_LOW,      stateClass: 'is-low' };
    if (remaining <= 10) return { remaining: remaining, headText: CFG.SLOT_MSG_MID,      stateClass: 'is-mid' };

    return { remaining: remaining, headText: CFG.SLOT_MSG_DEFAULT, stateClass: '' };
  }

  // -----------------------------
  // DOM update per widget
  // -----------------------------
  function tickWidget(root) {
    // required elements (match your snippet exactly)
    var readyEl = root.querySelector('[data-rush-ready]');
    var cdWrap = root.querySelector('[data-rush-countdown]');
    var labelEl = cdWrap ? cdWrap.querySelector('.rush-label') : null;
    var valueEl = cdWrap ? cdWrap.querySelector('.rush-value') : null;

    // optional slots block (still present in your snippet)
    var slotsWrap = root.querySelector('[data-rush-slots]');
    var headEl = slotsWrap ? slotsWrap.querySelector('[data-slots-head]') : null;
    var leftEl = slotsWrap ? slotsWrap.querySelector('[data-slots-left]') : null;

    if (!readyEl || !cdWrap || !labelEl || !valueEl) return;

    var now = nowLA();

    // Countdown + Ready text
    labelEl.textContent = CFG.COUNTDOWN_LABEL;

    var cd = computeCountdownState(now);
    var secs = secondsBetween(now, cd.countdownTo);
    valueEl.textContent = formatHM(secs);
    readyEl.textContent = cd.readyText;

    // warn class: apply to countdown row only, keep snippet’s base classes intact
    cdWrap.classList.toggle('rush-warn', !!cd.warn);

    // Slots (if exists)
    if (slotsWrap && headEl && leftEl) {
      var s = computeSlotsState(now);

      // Reset state classes then apply
      slotsWrap.classList.remove('is-mid', 'is-low', 'is-critical', 'is-queue');
      if (s.stateClass) slotsWrap.classList.add(s.stateClass);

      headEl.textContent = s.headText;

      if (s.remaining > 0) {
        leftEl.textContent = String(s.remaining);
      } else {
        leftEl.textContent = '0';
      }
    }
  }

  // -----------------------------
  // Init (multiple widgets per page)
  // -----------------------------
  function init() {
    var widgets = document.querySelectorAll('[data-rush-widget]');
    if (!widgets || !widgets.length) return;

    function tickAll() {
      widgets.forEach(function (w) { tickWidget(w); });
    }

    tickAll();

    // Update once per minute is enough (no need for 1s intervals)
    setInterval(tickAll, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();